import { shelfComponents } from '@/features/shop/components/Shelf/ShelfComponents'
import { memo, useEffect, useMemo } from 'react'
import { type Shelf } from '@/features/shop/services/Shelves/types'
import { CouponsContextProvider } from '@/features/shop/components/Coupons/CouponsContext'
import { getCouponsFromShelves } from '@/features/shop/services/Shelves/utils'
import { trackSponsoredContentLoaded } from '@/features/shared/analytics/promotions'

type ShelvesRendererShelfType = Shelf<
  unknown,
  { beacons?: { onLoadBeacons?: string[] }; featuredTransactionID?: string } | undefined
>
type Props = {
  shelves: Shelf[]
  className?: string
  hideRatings?: boolean
}

export const ShelvesRenderer = memo<Props>(({ shelves, className, hideRatings }) => {
  useEffect(() => {
    shelves.forEach((shelf: ShelvesRendererShelfType) => {
      shelf.metadata?.beacons?.onLoadBeacons?.forEach((beaconUrl) => {
        trackSponsoredContentLoaded({
          beaconUrl,
          featuredTransactionID: shelf.metadata?.featuredTransactionID ?? '',
        })
      })
    })
  }, [shelves])

  const coupons = useMemo(() => getCouponsFromShelves(shelves), [shelves])
  return (
    <CouponsContextProvider coupons={coupons}>
      <div className={className}>
        {shelves.map((shelf, shelfIndex) => {
          if (!shelf.renderType || !(shelf.renderType in shelfComponents)) {
            return null
          }
          const ShelfComponent = shelfComponents[shelf.renderType]

          return (
            <ShelfComponent
              key={`${shelf.name}_${shelf.type}`}
              shelf={shelf}
              shelfIndex={shelfIndex}
              hideRatings={hideRatings}
            />
          )
        })}
      </div>
    </CouponsContextProvider>
  )
})
